export default [{
  path: '/data/categories',
  name: 'Category',
  component: () => import('@/views/admin/categories/Index.vue'),
  meta: {
    rule: 'editor',
    pageTitle: 'Category',
    breadcrumb: [{
        title: 'Home',
        url: '/'
      },
      {
        title: 'Data'
      },
      {
        title: 'Category',
        active: true
      },
    ],
  }
}]
